<script>
  import { _ } from "./i18n.js";
  import { onMount, onDestroy } from "svelte";
  import {
    f7,
    BlockTitle,
    List,
    ListItem,
    Button,
    Preloader,
    Link,
    SwipeoutActions,
    SwipeoutButton
  } from "framework7-svelte";
  import { getProfile } from "./UserService.js";
  import { getSecuredFirestore } from "./Firestore.js";
  import moment from "moment";

  export let f7router;
  let delivered;
  let swipingout;

  onMount(async () => {
    load();
  });

  let snapshotlistener;
  onDestroy(async () => {
    snapshotlistener && snapshotlistener();
  });

  function load() {
    getSecuredFirestore().then(function(firestore) {
      let orderRef = firestore.collection("orders");
      let orderQuery = orderRef
        .where("status", "==", "Delivered")
        .orderBy("created", "desc");
      snapshotlistener = orderQuery.onSnapshot(
        function(querySnapshot) {
          delivered = querySnapshot.docs;
        },
        function(err) {
          console.log(err);
          delivered = -1;
          f7.dialog.alert($_("order.errorLoading"));
        }
      );
    });
  }
</script>

<div style="height: 100%">
  {#if !delivered}
    <div
      style="align-items: center; display: flex; justify-content: center;
      flex-direction: column; height: 100%;">

      <Preloader />
    </div>
  {:else if delivered == -1}
    <div
      style="align-items: center; display: flex; justify-content: center;
      flex-direction: column; height: 100%;">

      <Button fill round large on:click={() => ((delivered = null), load())}>
        {$_('order.reload')}
        <span style="margin-left: 8px" class="icon icon-loop" />
      </Button>
    </div>
  {:else if delivered && delivered.length == 0}
    <div
      style="align-items: center; display: flex; justify-content: center;
      flex-direction: column; height: 100%;">
      <BlockTitle medium>
        <span style="margin-right: 8px" class="icon icon-wink" />
        {$_('orderDelivered.noOrders')}
      </BlockTitle>
    </div>
  {:else if delivered && delivered.length > 0}
    <List style="margin-top: 0px">
      {#each delivered as order}
        <ListItem
          swipeout
          on:swipeoutOpen={e => {
            swipingout = true;
          }}
          on:swipeoutClosed={e => {
            swipingout = false;
          }}
          on:click={e => {
            if (!swipingout) {
              f7router.navigate('/Order/' + order.id);
            }
          }}
          header="{$_('orderAll.pack', {
            values: {
              n: order
                .get('items')
                .reduce((total, item) => total + item.amount, 0)
            }
          })}, By {order.get('name')}"
          title={moment(order
              .get('created')
              .toDate()).format('Do MMMM YYYY, h:mm A')}>

          <SwipeoutActions right>
            <SwipeoutButton
              color="red"
              on:click={function(e) {
                let id = order.id;
                f7.dialog.confirm($_('order.deleteOrder.confirm'), () => {
                  f7.swipeout.close(f7.swipeout.el, function() {
                    let dialog = f7.dialog.preloader($_('order.deleting'));
                    getSecuredFirestore().then(function(firestore) {
                      firestore
                        .collection('orders')
                        .doc(id)
                        .delete()
                        .then(async function() {
                          dialog.close();
                          f7.toast
                            .create({
                              text: $_('order.delete.success'),
                              closeTimeout: 6000
                            })
                            .open();
                        })
                        .catch(function(e) {
                          console.log(e);
                          dialog.close();
                          f7.dialog.alert($_('order.delete.error'));
                        });
                    });
                  });
                });
              }}>
              {$_('base.delete')}
            </SwipeoutButton>
          </SwipeoutActions>

          <span slot="content-start">
            {#if order.get('status') === 'Pending'}
              <span
                style="margin-right: 10px; color: red"
                class="icon icon-pending" />
            {:else}
              <span
                style="margin-right: 10px; color: green"
                class="icon icon-deliverable" />
            {/if}
          </span>
        </ListItem>
      {/each}
    </List>
  {/if}
</div>
